// extracted by mini-css-extract-plugin
export default {"container":"tenantUsersList_container__A00gJ"};